import { UserApi } from '@/services/api';

/**
 * Verifies if a user has the necessary credentials to post to a specific platform
 * 
 * @param platform The social media platform to check (e.g., 'x')
 * @returns A promise that resolves to true if the user has connected credentials for the platform
 */
export const verifyPlatformConnection = async (platform: string): Promise<boolean> => {
  try {
    // Fetch the user's social accounts
    const accounts = await UserApi.getSocialAccounts();
    
    // Find the specified platform and check if it's connected
    const platformAccount = accounts.find(account => account.platform === platform);
    
    return !!platformAccount?.is_connected;
  } catch (error) {
    console.error(`Error verifying ${platform} connection:`, error);
    // If we can't verify, assume false to be safe
    return false;
  }
};

/**
 * Gets a user-friendly platform display name
 * 
 * @param platform The platform identifier ('x', etc.)
 * @returns A user-friendly display name
 */
export const getPlatformDisplayName = (platform: string): string => {
  switch (platform.toLowerCase()) {
    case 'x':
      return 'X (Twitter)';
    default:
      // Capitalize the first letter
      return platform.charAt(0).toUpperCase() + platform.slice(1);
  }
}; 